import React from 'react';
import classnames from 'classnames';

import * as styles from './WaveText.module.css';

export function WaveText({text, fadeInAfter, color}) {
  const containerClassNames = classnames({
    [styles.FadeIn]: fadeInAfter,
    [styles[`Color-${color}`]]: color,
  });

  const letters = text.split('');

  return (
    <p
      className={containerClassNames}
      styles={{
        animationDelay: fadeInAfter ? `${fadeInAfter}ms` : 0,
      }}
    >
      {letters.map((letter, index) => {
        return (
          <span
            key={index}
            className={styles.Letter}
            style={{
              animationDelay: `${index * 50}ms`,
            }}
          >
            {letter}
          </span>
        );
      })}
    </p>
  );
}
